import { createSlice } from "@reduxjs/toolkit";
import {
  getAllReport,
  getReportById,
  uploadScoutingReport,
  fetchMyGuysReports,
} from "./reportAction";

const initialState = {
  loading: false,
  success: false,
  error: null,
  reports: [],
  allReports: [],
  allReportsSuccess: false,
  allReportsError: null,
  allReportsLoading: false,
  report: {},
  reportSuccess: false,
  reportError: null,
  reportLoading: false,
  updateReportSuccess: false,
  updateReportError: null,
  updateReportLoading: false,
  updateReportAllSuccess: false,
  updateReportAllError: null,
  updateReportAllLoading: false,
  myGuysReports: [],
  myGuysReportsSuccess: false,
  myGuysReportsError: null,
  myGuysReportsLoading: false,
};

const reportSlice = createSlice({
  name: "scoutingReports",
  initialState,
  reducers: {
    // addReport: (state, action) => {
    //   state.loading = true;
    //   state.reports.push(action.payload);
    // },
    updateReport: (state, action) => {
      const { id, data } = action.payload;
      // Find the key (sheet) that contains the report
      console.log(data, "data");
      for (const key in state.reports) {
        const arr = state.reports[key];
        const idx = arr.findIndex((report) => report.id == id);
        if (idx !== -1) {
          arr[idx] = { ...arr[idx], ...data };
          break;
        }
      }
    },
    resetUploadState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    },
    // removeReport: (state, action) => {
    //   state.reports = state.reports.filter(
    //     (report) => report.id !== action.payload
    //   );
    // },
  },
  extraReducers: {
    // uploadScoutingReport
    [uploadScoutingReport.pending]: (state) => {
      state.loading = true;
      state.success = false;
    },
    [uploadScoutingReport.fulfilled]: (state, action) => {
      state.loading = false;
      state.success = true;
      state.reports = action.payload.playerReports;
    },
    [uploadScoutingReport.rejected]: (state, action) => {
      state.loading = false;
      state.success = false;
      state.error = action.payload;
    },
    //get all reports
    [getAllReport.pending]: (state) => {
      state.allReportsLoading = true;
      state.allReportsSuccess = false;
    },
    [getAllReport.fulfilled]: (state, action) => {
      state.allReportsLoading = false;
      state.allReportsSuccess = true;
      state.allReports = action.payload.playerReports;
    },
    [getAllReport.rejected]: (state, action) => {
      state.allReportsLoading = false;
      state.allReportsSuccess = false;
      state.allReportsError = action.payload;
    },
    //get report by id
    [getReportById.pending]: (state) => {
      state.reportLoading = true;
      state.reportSuccess = false;
    },
    [getReportById.fulfilled]: (state, action) => {
      state.reportLoading = false;
      state.reportSuccess = true;
      state.report = action.payload.playerReport;
    },
    [getReportById.rejected]: (state, action) => {
      state.reportLoading = false;
      state.reportSuccess = false;
      state.reportError = action.payload;
    },
    //my guys reports
    [fetchMyGuysReports.pending]: (state) => {
      state.myGuysReportsLoading = true;
      state.myGuysReportsSuccess = false;
    },
    [fetchMyGuysReports.fulfilled]: (state, action) => {
      state.myGuysReportsLoading = false;
      state.myGuysReportsSuccess = true;
      state.myGuysReports = action.payload.playerReports;
    },
    [fetchMyGuysReports.rejected]: (state, action) => {
      state.myGuysReportsLoading = false;
      state.myGuysReportsSuccess = false;
      state.myGuysReportsError = action.payload;
    },
  },
});

export const { addReport, updateReport, removeReport, resetUploadState } = reportSlice.actions;
export const selectReport = (state) => state.scoutingReports;
export default reportSlice.reducer;
